// ui/src/lib/redFlags.ts
import type { PredefinedRedFlag, RedFlagWithRationale, NormalizedRedFlag } from '../types';

/**
 * Normalize red flags from evaluation (string or object) to full display format.
 * Handles backward compatibility with old string-only format.
 */
export function normalizeRedFlags(
  rawFlags: (string | RedFlagWithRationale)[],
  definitions: PredefinedRedFlag[]
): NormalizedRedFlag[] {
  return rawFlags.map((flag) => {
    const id = typeof flag === 'string' ? flag : flag.id;
    const rationale = typeof flag === 'string' ? undefined : flag.rationale;
    const definition = definitions.find((d) => d.id === id);

    return {
      id,
      label: definition?.label ?? id,
      description: definition?.description ?? '',
      guidance: definition?.guidance ?? '',
      rationale: rationale || undefined,
    };
  });
}
